import { Component, ElementRef, input, model, ViewChild } from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "tabbed-detail-navigation",
  templateUrl: "tabbed-detail-navigation.html",
  imports: [AngularSvgIconModule],
})
export class TabbedDetailNavigation {
  @ViewChild("tabsnav", { read: ElementRef }) tabsnav: ElementRef;
  readonly tabs = input.required<{ title: string; subtitle: string }[]>();
  readonly activeTabIndex = model.required<number>();

  moveLeft() {
    this.activeTabIndex.update((activeTabIndex) => Math.max(0, activeTabIndex - 1));
    this.tabsnav.nativeElement.scrollLeft -= 300;
  }

  moveRight() {
    this.activeTabIndex.update((activeTabIndex) => Math.min(this.tabs().length - 1, activeTabIndex + 1));
    this.tabsnav.nativeElement.scrollLeft += 300;
  }
}
